/*
  File name: session.js
    Program Description:
    - This initializes the session-plugin module being used in the system
    that accommodates the roles, privileges, and the state of the current user.
*/

import Vue from 'vue'
import SessionPlugin from 'session-plugin'

Vue.use(SessionPlugin)

export default SessionPlugin
